import { RuleSchema, RuleJsonModel } from '../../domain/collection/rule/FlowDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import WorkFlowView from '../../components/rule/workflow/view/WorkFlowView';
import { RuleTypes } from '../../domain/collection/rule/RuleDomains';

export type RuleActions = 'CHANGE_RULE' | 'CHANGE_RULE_SCHEMA' | 'CHANGE_RULE_WORKFLOW_VIEW' | 'CHANGE_RULE_IS_UPDATE' | 'CLEAR_RULE' | 'CHANGE_RULE_DIRTY';

export const changeRule = (payload: RuleJsonModel | null) =>
  ({
    type: 'CHANGE_RULE',
    payload,
  }) as ReduxBaseAction<RuleJsonModel, RuleActions>;

export const changeRuleSchema = (payload: DeploymentModel<RuleSchema> | null) =>
  ({
    type: 'CHANGE_RULE_SCHEMA',
    payload,
  }) as ReduxBaseAction<DeploymentModel<RuleSchema>, RuleActions>;

export const changeWorkflowView = (payload: WorkFlowView | null) =>
  ({
    type: 'CHANGE_RULE_WORKFLOW_VIEW',
    payload,
  }) as ReduxBaseAction<WorkFlowView, RuleActions>;

export const changeRuleIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_RULE_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, RuleActions>;

export const clearRule = (ruleType?: RuleTypes) =>
  ({
    type: 'CLEAR_RULE',
    payload: ruleType || RuleTypes.MONITORING,
  }) as ReduxBaseAction<RuleTypes, RuleActions>;

export const changeRuleDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_RULE_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, RuleActions>;
